const setColumnWidths = (worksheet, data) => {
  let maxWidths = []
  const columnNames = data.length > 0 ? Object.keys(data[0]) : []

  columnNames.forEach((name, index) => {
    maxWidths[index] = name.length
  })

  data.forEach(row => {
    columnNames.forEach((name, index) => {
      const value = (row[name] || '').toString().trim()
      maxWidths[index] = Math.max(maxWidths[index], value.length)
    })
  })
  worksheet['!cols'] = maxWidths.map(width => ({ width }))
}

export { setColumnWidths }
